import React from 'react'
import { Preference, PreferenceCardMetaProps } from '../data/types'
import { Button } from './ui/Button'
import { EditIcon, DeleteIcon } from '../icons'


type Props = {
    preference: Preference
    meta: PreferenceCardMetaProps
    onEdit?: (preference: Preference) => void
    onDelete?: (preference: Preference) => void,
    [x: string]: any;
}

export const PreferenceCard = (props: Props) => {
    const { preference, meta, onEdit, onDelete } = props

    return (
        <div className="bg-gray-200 dark:bg-gray-700 p-4 rounded-lg">
            <div className="flex justify-between items-start mb-2">
                <div className="flex-1">
                    <h5 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">
                        {preference.name}
                    </h5>
                    {preference.category && (
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                            <span className="font-medium">{meta.categoryLabel}:</span> {preference.category}
                        </p>
                    )}
                    {preference.description && (
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            {preference.description}
                        </p>
                    )}
                </div>
                {(onEdit || onDelete) && (
                    <div className="flex gap-1 ms-2">
                        {onEdit && (
                            <Button onClick={() => onEdit(preference)} variant="icon" size="sm" title="Edit preference">
                                <EditIcon className="w-4 h-4" />
                            </Button>
                        )}
                        {onDelete && (
                            <Button onClick={() => onDelete(preference)} variant="icon" color="danger" size="sm" title="Delete preference">
                                <DeleteIcon className="w-4 h-4" />
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )

}
